<template>
  <div class="table-responsive">
    <table class="table table-lg mb-0">
      <thead>
        <tr class="text-muted">
          <th>Názov prílohy</th>
          <th>Typ dokumentu</th>
          <th>Dátum zverejnenia</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="attachment in attachments" :key="`attachment-${attachment.id}`">
          <td><a :href="`https://storage.transparex.sk/documents/${attachment.path}${attachment.id}${attachment.suffix}`" target="_blank">{{attachment.name}}</a></td>
          <td>{{attachment.type}}</td>
          <td>{{attachment.publicationDate}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
var _ = require('lodash/string');

export default {
  name: 'DocumentsWidget',
  props: {
    documents: Array
  },
  data: function () {
    return {
      attachments: []
    }
  },
  watch: {
    documents () {
      this.attachments = []
      this.documents.filter(this.filterDocuments).sort(this.sortDocuments).forEach(document => {
        document.attachments.forEach(attachment => {
          if(!this.attachmentExists(attachment.fileId)) {
            this.attachments.push({
              id: attachment.fileId,
              path: document.path,
              name: attachment.name,
              type: document.type,
              publicationDate: document.publicationDate,
              suffix: attachment.name.substring(attachment.name.lastIndexOf('.'))
            })
          }
        })
      });
    }
  },
  methods: {
    filterDocuments(document) {
      let type = _.deburr(document.type)
      if (type.toLowerCase().includes("ponuky")) {
        return true
      }
      if (type.toLowerCase().includes("zapisnica")) {
        return true
      }
      if (type.toLowerCase().includes("sprava")) {
        return true
      }
      if (type.toLowerCase().includes("protokol")) {
        return true
      }
      if (type.toLowerCase().includes("vyhodnotenia")) {
        return true
      }
      if (type.toLowerCase().includes("iny")) {
        return true
      }      
      return false
    },
    sortDocuments(a, b) {
      const typeA = _.deburr(a.type).toUpperCase();
      const typeB = _.deburr(b.type).toUpperCase();

      let comparison = 0;
      if (typeA > typeB) {
        comparison = -1;
      } else if (typeA < typeB) {
        comparison = 1;
      }
      return comparison;
    },
    attachmentExists (id) {
      return !!this.attachments.find(attachment => {
        return attachment.id === id
      });
    }
  }
}
</script>

<style>

</style>